"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jquery_1 = __importDefault(require("jquery"));
var namespace_1 = __importDefault(require("../namespace"));
namespace_1.default.namespace.extend('controller', function (frameId) {
    this.frameId = frameId;
    this.idPrefix = 'controller';
    this.id = '';
    this.model = false;
    this.initialized = false;
    this.defObj = false;
    this.content = false;
    this.modelInstance;
    this.parent = {
        init: function (container, defObj) {
            if (defObj)
                this.defObj = defObj;
            namespace_1.default.debug.showInfo('#' + this.frameId + ': Initializing ' + this.id);
            if (!container)
                container = '';
            this.container = '#' + this.frameId + ' ' + container;
            this.bindEvents();
            this.getData();
            return this.id;
        },
        bindEvents: function () {
            if (this.model) {
                (0, jquery_1.default)(document).on(this.frameId + namespace_1.default.events.model.send + this.model, this.checkViewHandler = this.checkView.bind(this));
            }
            (0, jquery_1.default)(document).on(this.frameId + namespace_1.default.events.controller.kill + this.id, this.killHandler = this.kill.bind(this));
        },
        kill: function (ev) {
            namespace_1.default.debug.showInfo('#' + this.frameId + ': Killing controller ' + this.id);
            (0, jquery_1.default)(document).off(this.frameId + namespace_1.default.events.model.send + this.model, this.checkViewHandler);
            if (this.model) {
                var tEvent = jquery_1.default.Event(this.frameId + namespace_1.default.events.model.kill + this.model);
                (0, jquery_1.default)(document).triggerHandler(tEvent);
                this.model = false;
            }
            (0, jquery_1.default)(document).off(this.frameId + namespace_1.default.events.controller.kill + this.id, this.killHandler);
        },
        checkView: function (ev) {
            if (this.initialized) {
                this.update(ev);
            }
            else {
                namespace_1.default.debug.showInfo('#' + this.frameId + ': Rendering view for ' + this.id);
                this.render(ev);
            }
        },
        render: function (ev) {
            this.initialized = true;
            if (ev)
                this.content = ev.content;
            var view = this.view();
            view.frameId = this.frameId;
            (0, jquery_1.default)(this.container).html(view.get(this.content));
            var tEvent = jquery_1.default.Event(namespace_1.default.events.stylefills.checkStyles);
            (0, jquery_1.default)(document).triggerHandler(tEvent);
            if (this.defObj)
                this.defObj.resolve();
        },
        update: function (ev) {
            // default does nothing as we don't assume that this is a live-controller.
        },
        getData: function () {
            if (this.model != false) {
                var tModelArr = this.model.split(':');
                var tObj = namespace_1.default.visual[namespace_1.default.items[this.frameId].config.namespace];
                var breakLoop = false;
                tModelArr.forEach(function (el) {
                    if (tObj[el] && !breakLoop) {
                        tObj = tObj[el];
                    }
                    else {
                        breakLoop = true;
                    }
                });
                if (breakLoop) {
                    namespace_1.default.debug.showError(this.controller + ' - function: getData - ' + this.model + ' not found');
                }
                else {
                    this.modelInstance = new tObj(this.frameId);
                    this.modelInstance.init();
                }
            }
            else {
                this.render();
            }
        }
    };
    this.init = this.parent.init;
    this.bindEvents = this.parent.bindEvents;
    this.kill = this.parent.kill;
    this.checkView = this.parent.checkView;
    this.render = this.parent.render;
    this.update = this.parent.update;
    this.getData = this.parent.getData;
    this.view = function ( /* data */) {
        namespace_1.default.debug.showError('.getView has to be extended in ' + this.id);
    };
});
